import L from 'leaflet';

const positionInBounds = (position, bounds) => {
  return L.latLngBounds(bounds[0], bounds[1]).contains(position);
};

const maxBoundsCorners = [[48.5, -22.5], [62.0, 11.8]];

const getMinBounds = (center, stores, numberOfStores, maxRadius, adjustments = {south: 1, west: 1, north: 1, east: 1}) => {
  let locations = [];

  stores.forEach((store) => {
    if (store.distance <= maxRadius) {
      locations.push(store);
    }
  });
  
  if (locations.length === 0) {
    locations = stores.slice(0, numberOfStores);
  }

  let lats = [];
  let lngs = [];

  locations.forEach((location) => {
    lats.push(Math.abs(center.lat - location.lat));
    lngs.push(Math.abs(center.lng - location.lng));
  });

  let sw = {
    lat: center.lat - Math.max(...lats) * adjustments.south,
    lng: center.lng - Math.max(...lngs) * adjustments.west
  };
  let ne = {
    lat: center.lat + Math.max(...lats) * adjustments.north,
    lng: center.lng + Math.max(...lngs) * adjustments.east
  };

  return [sw, ne];
};

const getPosition = (options) => {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  ).then(res => {
    return {lat: res.coords.latitude, lng: res.coords.longitude};
  });
};

const isMobileScreen = () => {
  let viewport = 768; //change this, when the mobile breakpoint changes in the framework
  return (window.screen.availWidth && window.screen.availWidth < viewport);
};

export {positionInBounds, getMinBounds, getPosition, isMobileScreen, maxBoundsCorners};
